<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">

      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center justify-content-between text-white" style="padding: 32px 0;">
            <div class="d-flex align-items-center">
              <div class="header-icon-wrap mr-3">
                <i class="fe fe-list" style="font-size: 22px;"></i>
              </div>
              <div>
                <h4 class="mb-0 font-weight-bold">Manage Encounters</h4>
                <small style="opacity: 0.8;">
                  <span v-if="encounters != ''">{{ encounters.meta.total }}</span> encounters
                </small>
              </div>
            </div>
            <div class="d-flex" style="gap: 8px;">
              <button class="btn btn-light btn-sm" style="border-radius: 8px; font-weight: 600;"
                @click="encounterform = !encounterform">
                <i class="fe mr-1" :class="encounterform ? 'fe-x' : 'fe-plus'"></i>
                {{ encounterform ? 'Close' : 'Add Code' }}
              </button>
              <button class="btn btn-outline-light btn-sm" style="border-radius: 8px; font-weight: 600;"
                @click="filterparams = !filterparams">
                <i class="fe fe-filter mr-1"></i> Filter
              </button>
            </div>
          </div>
        </div>
      </div>

      <section style="margin-top: -20px;">
        <div class="container pb-5">

          <!-- Encounter code form -->
          <div v-show="encounterform" class="card shadow-sm form-card mb-4">
            <div class="form-card-header">
              <div class="section-number"><i class="fe fe-plus" style="font-size: 13px;"></i></div>
              <h6 class="mb-0 font-weight-bold text-white">Add Encounter Code</h6>
            </div>
            <div class="card-body px-4 py-4">
              <form @submit.prevent="sendCode">
                <div class="form-group">
                  <label class="info-label d-block mb-1">Encounter Code</label>
                  <input type="text" required class="form-control" v-model="string_data"
                    placeholder="EC0/000/000/000" />
                </div>

                <button type="submit" class="btn btn-submit">
                  <i class="fe fe-send mr-1"></i> Submit
                </button>
              </form>
            </div>
          </div>

          <!-- Filter form -->
          <div v-show="filterparams" class="card shadow-sm form-card mb-4">
            <div class="form-card-header">
              <div class="section-number"><i class="fe fe-filter" style="font-size: 13px;"></i></div>
              <h6 class="mb-0 font-weight-bold text-white">Filter Encounters</h6>
            </div>
            <div class="card-body px-4 py-4">
              <div class="row">
                <div class="form-group col-md-6">
                  <label class="info-label d-block mb-1">Agency ID</label>
                  <input type="text" class="form-control" v-model="filter_field.enrollee" placeholder="ID/XXX/XXXXX" />
                </div>

                <div class="form-group col-md-6">
                  <label class="info-label d-block mb-1">Diagnosis</label>
                  <v-select multiple v-model="filter_field.diagnoses" :reduce="(name) => name.id" label="name"
                    :options="diseases" />
                </div>

                <div class="form-group col-md-6" v-if="user.type == 'shis' || user.type == 'employee'"
                  :reduce="agency_name => agency_name.id">
                  <label class="info-label d-block mb-1">Select Facility</label>
                  <v-select v-model="filter_field.providers" label="agency_name" :options="providers" multiple />
                </div>

                <div class="form-group col-md-6">
                  <label class="info-label d-block mb-1">LGA</label>
                  <select @click="fetchLga" class="form-control" v-model="filter_field.localgovt">
                    <option value="">All LGAs</option>
                    <option v-for="lga in lga_states" v-bind:key="lga.id" :value="lga.id">
                      {{ lga.local_name }}
                    </option>
                  </select>
                </div>

                <div class="form-group col-md-6">
                  <label class="info-label d-block mb-1">Select Sector</label>
                  <select class="form-control" v-model="filter_field.sector">
                    <option value="">All Sectors</option>
                    <option :value="sector" v-for="sector in sectors" :key="sector">
                      {{ sector }}
                    </option>
                  </select>
                </div>

                <div class="form-group col-md-6">
                  <label class="info-label d-block mb-1"><i class="fe fe-calendar mr-1"></i>Start Date</label>
                  <input type="date" class="form-control" v-model="filter_field.from" />
                </div>

                <div class="form-group col-md-6">
                  <label class="info-label d-block mb-1"><i class="fe fe-calendar mr-1"></i>End Date</label>
                  <input type="date" class="form-control" v-model="filter_field.to" />
                </div>

                <div class="form-group col-md-6">
                  <label class="info-label d-block mb-1">Confirmed</label>
                  <select class="form-control" v-model="filter_field.is_confirmed">
                    <option value="">All</option>
                    <option :value="true">Yes</option>
                    <option :value="false">No</option>
                  </select>
                </div>

                <div class="form-group col-md-6">
                  <label class="info-label d-block mb-1">Rows</label>
                  <select class="form-control" v-model="paginate_value">
                    <option>30</option>
                    <option>100</option>
                    <option>500</option>
                    <option>1000</option>
                    <option>5000</option>
                    <option>10000</option>
                    <option>15000</option>
                    <option>40000</option>
                    <option>50000</option>
                    <option>100000</option>
                  </select>
                </div>
              </div>

              <div class="d-flex" style="gap: 8px;">
                <button class="btn btn-submit" @click="getEncounters('json')">
                  <i class="fe fe-search mr-1"></i> Filter
                </button>
                <button class="btn btn-outline-secondary" @click="getEncounters('csv')">
                  <i class="fe fe-download mr-1"></i> Export CSV
                </button>
              </div>
            </div>
          </div>

          <!-- Encounters table -->
          <div class="card shadow-sm table-card">
            <div class="d-flex align-items-center px-4 pt-4 pb-3">
              <i class="fe fe-list text-primary mr-2"></i>
              <h6 class="mb-0 font-weight-bold">Encounters</h6>
              <span v-if="encounters != ''" class="badge badge-soft-info ml-2">{{ encounters.meta.total }}</span>
            </div>
            <div class="table-responsive">
              <table class="table align-td-middle mb-0">
                <thead class="table-head">
                  <tr>
                    <th class="table-th">Encounter ID</th>
                    <th class="table-th">Facility</th>
                    <th class="table-th">Patient</th>
                    <th class="table-th">Phone Number</th>
                    <th class="table-th">Diagnosis</th>
                    <th class="table-th">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="encounter in encounters.data" v-bind:key="encounter.id" class="table-row">
                    <td class="py-3 px-4">
                      <span v-if="encounter.healthrecord != null">
                        {{ encounter.healthrecord.encounter_id }}
                      </span>
                      <span v-if="encounter.is_confirmed == true">
                        <button type="button" class="btn mx-1 badge badge-soft-success">confirmed</button>
                      </span>
                      <span v-if="encounter.is_confirmed == false">
                        <button type="button" class="btn mx-1 badge badge-soft-danger">rejected</button>
                      </span>
                    </td>
                    <td class="py-3">
                      <span v-if="encounter.provider != null">
                        {{ encounter.provider.agency_name }}
                      </span>
                    </td>
                    <td class="py-3 font-weight-bold">
                      <span v-if="encounter.enrollee != null">
                        {{ encounter.enrollee.full_name }}</span>
                    </td>
                    <td class="py-3 text-muted small">
                      <span v-if="encounter.enrollee != null">
                        {{ encounter.enrollee.phone_number }}</span>
                    </td>
                    <td class="py-3">
                      <span v-if="encounter.diagnosis != null">{{ encounter.diagnosis.name }}</span>
                    </td>

                    <td class="py-3 pr-4">
                      <router-link :to="{ path: '/encounter/' + encounter.id }">
                        <button type="button" class="btn btn-sm btn-submit" name="button">
                          <i class="fe fe-eye"></i>
                        </button>
                      </router-link>
                    </td>
                  </tr>
                  <tr v-if="encounters == '' || !encounters.data || !encounters.data.length">
                    <td colspan="6" class="text-center py-5 text-muted">
                      <i class="fe fe-inbox" style="font-size: 2rem; opacity: 0.3;"></i>
                      <p class="mt-2 mb-0">No encounters. Use the filter to search.</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="vld-parent">
            <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
          </div>
        </div>
      </section>
    </main>
  </section>
</template>

<script>
  import Navbar from "@/views/Navbar.vue";
  import Loading from "vue-loading-overlay";
  import "vue-loading-overlay/dist/vue-loading.css";
  import SectorsJson from "@/json/sectors.json";

  export default {
    components: {
      Navbar,
      Loading,
    },
    data() {
      return {
        paginate_value: 30,
        user: null,
        isLoading: false,
        encounterform: false,
        fullPage: true,
        filterparams: false,
        diseases: "",
        providers: "",
        string_data: "",
        lga_states: "",
        sectors: SectorsJson,
        json_fields: {
          "Encounter ID": "healthrecord.encounter_id",
          "Enrollee Full Name": "enrollee.full_name",
          "Enrollee AGENCY ID": "enrollee.id_card_number",
          "Enrollee Phone Number": "enrollee.phone_number",
          "Enrollee Place of Work": "enrollee.place_of_work",
          Diagnosis: "diagnosis.name",
          // secondary and other diagnoses, joined with "; " (service_summary-agency list)
          "Other Diagnoses": "other_diagnoses_text",
          "Facility Name": "provider.agency_name",
        },
        encounters: {
          meta: {},
        },
        filter_field: {
          diagnoses: [],
          providers: [],
          enrollee: "",
          localgovt: "",
          sector: "",
          date: "",
          from: "",
          to: "",
          is_confirmed: "",
        },
      };
    },
    beforeMount() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/diagnosis-agency/90`)
        .then((response) => {
          this.diseases = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    methods: {
      getEncounters(format) {
        this.isLoading = true;
        this.axios
          .post(`/api/v1/auth/service_summary-agency`, {
            format: format,
            providers: this.filter_field.providers,
            enrollee: this.filter_field.enrollee,
            diagnoses: this.filter_field.diagnoses,
            localgovt: this.filter_field.localgovt,
            sector: this.filter_field.sector,
            is_confirmed: this.filter_field.is_confirmed,
            date: this.filter_field.date,
            from: this.filter_field.from,
            to: this.filter_field.to,
            agency_id: 90,
            paginate_value: this.paginate_value,
          })
          .then((response) => {

            if (format === "csv") {
              const blob = new Blob([response.data], {
                type: "text/csv;charset=utf-8;",
              });
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute(
                "download",
                `encounters_${new Date().toISOString().slice(0, 10)}.csv`
              );
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);

              this.$toasted.success("CSV downloaded successfully", {
                position: "top-center",
                duration: 3000,
              });

              this.isLoading = false;
              return;
            }

            this.isLoading = false;
            this.encounters = response.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
            this.isLoading = false;
          });
      },

      sendCode() {
        if (confirm("Are you Sure you want submit")) {
          this.isLoading = true;
          this.axios
            .post(`/api/v1/auth/get-string`, {
              string_data: this.string_data,
              agency_id: 90,
            })
            .then((response) => {
              console.log(response);
              this.getEncounters('json');
              this.string_data = "";
              this.isLoading = false;
              this.$toasted.info("Encounted submitted Successfully!", {
                position: "top-center",
                duration: 3000,
              });
            })
            .catch((error) => {
              console.error(error);
              this.isLoading = false;
              this.$toasted.error("Code Error!", {
                position: "top-center",
                duration: 3000,
              });
            });
        }
      },
      getProviders() {
        this.axios
          .get(`/api/v1/auth/providerAgency/90`)
          .then((response) => {
            this.providers = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },
      fetchLga() {
        if (this.lga_states == "") {
          this.isLoading = true;
          this.axios
            .get(`/api/v1/auth/lga/2669`)
            .then((response) => {
              this.lga_states = response.data.data;
              console.log(response);
              this.isLoading = false;
            })
            .catch((error) => {
              console.error(error);
              this.isLoading = false;
            });
        } else {
          console.log(this.lga_states);
        }
      },
    },
    created() {
      this.getEncounters('json');
      this.getProviders();
    },
  };
</script>

<style scoped>
.page-header {
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
  padding-bottom: 40px;
}

.header-icon-wrap {
  width: 48px; height: 48px;
  background: rgba(255,255,255,0.15);
  border-radius: 12px;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
}

.form-card, .table-card { border-radius: 12px; border: 1px solid #e9ecef; overflow: hidden; }

.form-card-header {
  display: flex; align-items: center; gap: 12px;
  padding: 14px 20px;
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
}

.section-number {
  width: 28px; height: 28px; background: rgba(255,255,255,0.2);
  border-radius: 8px; display: flex; align-items: center; justify-content: center;
  color: #fff; flex-shrink: 0;
}

.info-label {
  font-size: 0.78rem; font-weight: 600;
  text-transform: uppercase; letter-spacing: 0.04em;
  color: #64748b;
}

.btn-submit {
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
  border: none; color: #fff; border-radius: 8px;
  font-weight: 600; padding: 8px 20px;
}
.btn-submit:hover { opacity: 0.9; color: #fff; }

.table-th {
  font-size: 0.73rem; text-transform: uppercase; letter-spacing: 0.04em;
  color: #64748b; font-weight: 600;
  border-bottom: 2px solid #e2e8f0; padding: 12px 16px;
}

.table-row:hover { background: #f8fafc; }
</style>
